import 'budicons2/Outline/style.css';
import './style/style.scss';

import {
    searchDepartmentId,
    searchDepartments,
    searchUsersPost
} from './scripts/services/search';

import UserTemplate from './scripts/templates/userList';
import {toggleAccordion} from './scripts/features/accordion';
import {getFragment} from "./scripts/features/tools";
import store from './scripts/store';

import {
    ACCOR_BUTTON,
    SEARCH_INPUT,
    SEARCH_BUTTON,
    LOAD_MORE_BUTTON,
    DEPARTMENT_SELECT,
    SECTION_SELECT,
    SORT_SELECT
} from "./scripts/constants/elementConst";

import {appendUsers, renderUsers} from "./scripts/features/render";
import {PREFIX} from "./scripts/constants/styleConst";
import {sectionTemplate} from "./scripts/templates/section";
import {ACC, DESC} from "./scripts/constants/sortConst";

export default async function({
    clientId,
    url,
    target,
    defaultDepartment,
    noInitUsers,
    multiPhoneSupport,
    caption,
    config}){

    if(target){
        target.classList.add(`${PREFIX}`);
        target.classList.add(`${PREFIX}__loader`);

        store.set("url", url);
        store.set("clientId", clientId);

        if(config && config.search){
            store.set("searchOption",config.search);
        }

        if(defaultDepartment && defaultDepartment.trim().length > 0){
            store.set("defaultDepartment",defaultDepartment);
            
            try{
                const departmentData = await searchDepartmentId();
                const searchOption = store.get("searchOption");
                searchOption.Department.DepartmentId = departmentData.DepartmentId;
    
                store.set("isFilterVisible",true);
                store.set("searchOption",searchOption);
            }catch (e) {
                target.classList.remove(`${PREFIX}__loader`);
                target.innerHTML = "Feil ved lasting av departmentId: " + e;

                return;
            }
        }

        if(caption){
            if(caption.searchPlaceholder){
                store.set("searchPlaceholderCaption",caption.searchPlaceholder);
            }

            if(caption.selectDepartment){
                store.set("selectDepartmentCaption",caption.selectDepartment);
            }

            if(caption.selectSection){
                store.set("selectSectionCaption",caption.selectSection);
            }
        }

        if(multiPhoneSupport){
            store.set("multiPhoneSupport",multiPhoneSupport);
        }

        try {
            if(noInitUsers && !defaultDepartment){
                store.set("noInitUsers", noInitUsers);
                const [departmentData] = await Promise.all([
                    searchDepartments()
                ]);

                store.set("departmentList",departmentData);
            }else{
                const [userData, departmentData] = await Promise.all([
                    searchUsersPost(),
                    searchDepartments()
                ]);

                store.set("departmentList",departmentData);
                store.set("userList",userData.SearchResultUsers);
                store.set("totalCount",userData.TotalCount);
                store.set("currentCount",userData.SearchResultUsers.length);
                store.set("searchOptionNext",userData.NextSearchOptions);
            }

            target.innerHTML = UserTemplate();
            target.classList.remove(`${PREFIX}__loader`);

            target.addEventListener("click", async (event) => {
                let targetElement = event.target;

                if(!targetElement.getAttribute("data-click")){
                    targetElement = targetElement.closest("[data-click]");
                }

                if(!targetElement) return;

                switch (targetElement.getAttribute("data-click")) {
                    case ACCOR_BUTTON:
                        toggleAccordion(targetElement,target);
                        break;
                    case SEARCH_BUTTON:
                        await renderUsers(target);
                        break;
                    case LOAD_MORE_BUTTON:
                        targetElement.classList.add(`${PREFIX}__loader`);
                        targetElement.style.display="flex";

                        await appendUsers(target);
                        break;
                }
            });

            target.addEventListener("change", async (event) => {
                let searchOption = null;

                switch (event.target.getAttribute("data-js")) {
                    case DEPARTMENT_SELECT:
                        searchOption = store.get("searchOption");
                        searchOption.Department.DepartmentId = event.target.value;
                        store.set("searchOption", searchOption);

                        getFragment(target,SECTION_SELECT).innerHTML = sectionTemplate();

                        await renderUsers(target);

                        break;
                    case SECTION_SELECT:
                        searchOption = store.get("searchOption");
                        searchOption.Department.SectionId = event.target.value;
                        store.set("searchOption",searchOption);

                        await renderUsers(target);
                        break;
                    case SORT_SELECT:
                        searchOption = store.get("searchOption");

                        if(event.target.value === ACC){
                            searchOption.Sort.SortField = "SurName";
                            searchOption.Sort.SortDirection = ACC;
                        }else if(event.target.value === DESC){
                            searchOption.Sort.SortField = "SurName";
                            searchOption.Sort.SortDirection = DESC;
                        }else{
                            searchOption.Sort.SortField = "";
                            searchOption.Sort.SortDirection = "";
                        }

                        await renderUsers(target);

                        break;
                }
            });

            const searchInput = target.querySelector(`[data-js='${SEARCH_INPUT}']`);
            searchInput.addEventListener("keypress", async (event) => {
                if (event.keyCode === 13) {
                    await renderUsers(target);
                }
            });

            searchInput.addEventListener("keyup", (event) => {
                const searchOption = store.get("searchOption");
                searchOption.SearchQuery = event.target.value.trim();
                store.set("searchOption",searchOption);
            });
        }catch (e) {
            target.classList.remove(`${PREFIX}__loader`);
            target.innerHTML = "Feil ved lasting av departement og brukere: " + e;
        }
    }
}